export const AFILIACIONES_PERMISOS = {
  ALTA: 'Afiliaciones_Alta',
  BAJA: 'Afiliaciones_Baja',
  CONSULTA: 'Afiliaciones_Consulta',
  MODIFICACION: 'Afiliaciones_Modificar',
  CAMBIO_TITULARIDAD: 'Afiliaciones_CambioTitularidad',
  REACTIVACION: 'Afiliaciones_Reactivacion',
};

export const EMPRESAS_PERMISOS = {
  ALTA: 'Empresas_Alta',
  BAJA: 'Empresas_Baja',
  CONSULTA: 'Empresas_Consulta',
  MODIFICACION: 'Empresas_Modificar',
};

export const SECCIONALES_PERMISOS = {
  ALTA: 'Seccionales_Alta',
  BAJA: 'Seccionales_Baja',
  CONSULTA: 'Seccionales_Consulta',
  MODIFICACION: 'Seccionales_Modificar',
};

export const CATEGORIA_PERMISOS = {
  ALTA: 'Categoria_Alta',
  BAJA: 'Categoria_Baja',
  CONSULTA: 'Categoria_Consulta',
  MODIFICACION: 'Categoria_Modificar',
};

export const TIPO_DOCUMENTACION_PERMISOS = {
  ALTA: 'TipoDocumentacion_Alta',
  BAJA: 'TipoDocumentacion_Baja',
  CONSULTA: 'TipoDocumentacion_Consulta',
  MODIFICACION: 'TipoDocumentacion_Modificar',
};

export const TIPO_AFILIACION_PERMISOS = {
  ALTA: 'TipoAfiliacion_Alta',
  BAJA: 'TipoAfiliacion_Baja',
  CONSULTA: 'TipoAfiliacion_Consulta',
  MODIFICACION: 'TipoAfiliacion_Modificar',
};

export const TIPO_PARENTESCO_PERMISOS = {
  ALTA: 'TipoParentesco_Alta',
  BAJA: 'TipoParentesco_Baja',
  CONSULTA: 'TipoParentesco_Consulta',
  MODIFICACION: 'TipoParentesco_Modificar',
};

export const DOCUMENTOS_TIPO_PERMISOS = {
  ALTA: 'DocumentosPorTipo_Alta',
  BAJA: 'DocumentosPorTipo_Baja',
  CONSULTA: 'DocumentosPorTipo_Consulta',
  MODIFICACION: 'DocumentosPorTipo_Modificar',
};

export const DOCUMENTOS_PARENTESCO_PERMISOS = {
  ALTA: 'DocumentosPorParentesco_Alta',
  BAJA: 'DocumentosPorParentesco_Baja',
  CONSULTA: 'DocumentosPorParentesco_Consulta',
  MODIFICACION: 'DocumentosPorParentesco_Modificar',
};

export const CATEGORIA_TIPO_AFILIADO_PERMISOS = {
  ALTA: 'CategoriaPorTipoAfiliado_Alta',
  BAJA: 'CategoriaPorTipoAfiliado_Baja',
  CONSULTA: 'CategoriaPorTipoAfiliado_Consulta',
  MODIFICACION: 'CategoriaPorTipoAfiliado_Modificar',
};

export const ESTADO_CIVIL_PERMISOS = {
  ALTA: 'EstadoCivil_Alta',
  BAJA: 'EstadoCivil_Baja',
  CONSULTA: 'EstadoCivil_Consulta',
  MODIFICACION: 'EstadoCivil_Modificar',
};

export const USUARIOS_PERMISOS = {
  ALTA: 'Usuarios_Alta',
  BAJA: 'Usuarios_Baja',
  CONSULTA: 'Usuarios_Consulta',
  MODIFICACION: 'Usuarios_Modificar',
};

export const ROLES_PERMISOS = {
  ALTA: 'Roles_Alta',
  BAJA: 'Roles_Baja',
  CONSULTA: 'Roles_Consulta',
  MODIFICACION: 'Roles_Modificar',
};

export const PERMISOS_PERMISOS = {
  CONSULTA: 'Permisos_Consulta',
  MODIFICACION: 'Permisos_Modificar',
};

export const BANDEJA_PERMISOS = {
  ALTA: 'Bandeja_Alta',
  BAJA: 'Bandeja_Baja',
  CONSULTA: 'Bandeja_Consulta',
  MODIFICACION: 'Bandeja_Modificar',
};

export const BANDEJA_CONTRATOS_PERMISOS = {
  ALTA: 'Bandeja_Contratos_Alta',
  BAJA: 'Bandeja_Contratos_Baja',
  CONSULTA: 'Bandeja_Contratos_Consulta',
  MODIFICACION: 'Bandeja_Contratos_Modificar',
};

export const ADMINISTRAR_PREAFILIACIONES_PERMISOS = {
  ALTA: 'AdministrarPreAfiliaciones_Alta',
  BAJA: 'AdministrarPreAfiliaciones_Baja',
  CONSULTA: 'AdministrarPreAfiliaciones_Consulta',
  MODIFICACION: 'AdministrarPreAfiliaciones_Modificar',
  LIBERAR: 'AdministrarPreAfiliaciones_Liberar',
};

export const PREAFILIACIONES_PERMISOS = {
  ALTA: 'PreAfiliaciones_Alta',
  BAJA: 'PreAfiliaciones_Baja',
  CONSULTA: 'PreAfiliaciones_Consulta',
  MODIFICACION: 'PreAfiliaciones_Modificar',
};

export const CANDIDATO_BAJAS_PERMISOS = {
  ALTA: 'CandidatoABajas_Alta',
  BAJA: 'CandidatoABajas_Baja',
  CONSULTA: 'CandidatoABajas_Consulta',
  MODIFICACION: 'CandidatoABajas_Modificar',
};

export const REPORTES_PERMISOS = {
  CONSULTA: 'Reportes_Consulta',
};

export const REPORTE_DINAMICO_PERMISOS = {
  CONSULTA: 'Reporte_Dinamico_Consulta',
};

export const CONTACTOSWEB_PERMISOS = {
  CONSULTA: 'Contactos_Web',
};

export const MOVIMIENTOSUSER_PERMISOS = {
  CONSULTA: 'Movimientos_User',
};

export const TURNOS_PERMISOS = {
  ALTA: 'Turnos_Alta',
  BAJA: 'Turnos_Baja',
  CANCELAR: 'Turnos_Cancelar',
  CONSULTA: 'Turnos_Consulta',
  ASISTENCIA: 'Turnos_Asistencia',
  MODIFICACION: 'Turnos_Modificar',
  SOBRETURNOS: 'Turnos_SobreTurnos',
  AGREGAR_PRACTICA: 'Turnos_AgregrPractica',
  EXENTAR_PAGO_TURNO: 'Turnos_ExentarPagoTurno',
  PERMITE_SALTAR_PAGO_AUNQ_EXEDE_LIMITE:
    'Turnos_PermiteSaltarPagoAunqExedeLimite',
  PERMITE_CANCELAR_ASISTENCIA_SIN_MIRAR_FECHA:
    'CancelarAsistenciaSinMirarFecha_ADMIN',
  PERMITE_SELECCIONAR_MEDIOS_PAGO_NO_HABILITADOS:
    'VerMediosPagoNoHabilitados_ADMIN',
  PAGO_ADELANTADO_TURNO: 'PagoAdelantaodoTurnos',
  BANDEJA_ESTUDIOS_MEDICOS: 'turnos_estudiosMedicos'
};

export const CONFIGURACIONTURNOS_PERMISOS = {
  ALTA: 'ConfiguracionTurnos_Alta',
  BAJA: 'ConfiguracionTurnos_Baja',
  CONSULTA: 'ConfiguracionTurnos_Consulta',
  MODIFICACION: 'ConfiguracionTurnos_Modificar',
  GENERACION_ADMIN: 'ConfiguracionTurnos_GeneracionSoloAdmin',
};

export const RESOLUCIONESFACTURACION_PERMISOS = {
  ALTA: 'ResolucionesFacturacion_Alta',
  BAJA: 'ResolucionesFacturacion_Baja',
  CONSULTA: 'ResolucionesFacturacion_Consulta',
  MODIFICACION: 'ResolucionesFacturacion_Modificar',
};

export const CUOTASFACTURACION_PERMISOS = {
  ALTA: 'CuotasFacturacion_Alta',
  BAJA: 'CuotasFacturacion_Baja',
  CONSULTA: 'CuotasFacturacion_Consulta',
  MODIFICACION: 'CuotasFacturacion_Modificar',
};

export const FACTURACION_PERMISOS = {
  ALTA: 'Facturacion_Alta',
  CONSULTA: 'Facturacion_Consulta',
  ANULACION: 'Facturacion_Anulacion',
};
export const ARQUEO_PERMISOS = {
  ARQUEO_VER_TODOS_CM: 'ARQUEO_VER_TODOS_CM',
  ARQUEO_VER_SOLO_CENTRO_MEDICO: 'ARQUEO_VER_SOLO_CENTRO_MEDICO',
};
export const MOTIVOSBAJATURNOS_PERMISOS = {
  ALTA: 'MotivosBajaTurnos_Alta',
  BAJA: 'MotivosBajaTurnos_Baja',
  CONSULTA: 'MotivosBajaTurnos_Consulta',
  MODIFICACION: 'MotivosBajaTurnos_Modificar',
};

export const LICENCIASPROFESIONALES_PERMISOS = {
  ALTA: 'LicenciasProfesionales_Alta',
  BAJA: 'LicenciasProfesionales_Baja',
  CONSULTA: 'LicenciasProfesionales_Consulta',
  MODIFICACION: 'LicenciasProfesionales_Modificar',
};

export const FERIADOS_PERMISOS = {
  ALTA: 'Feriados_Alta',
  BAJA: 'Feriados_Baja',
  CONSULTA: 'Feriados_Consulta',
  MODIFICACION: 'Feriados_Modificar',
};

export const SOPORTEAFILIADOS_PERMISOS = {
  DATOS_CONTACTO: 'SoporteAfiliados_DatosContacto',
};

export const ARCHIVOS_PERMISOS = {
  TODO: 'ArchivosMigracion_Todo',
  MARCAR_BAJAS: 'ArchivosMigracion_MarcarBajas',
};

//CONTRATOS
export const CONTRATACIONES_PERMISOS = {
  CONSULTA: 'Contratos_Consultas',
  ADMINISTRACION: 'Contratos_Administracion',
};

export const CONTRATACIONES_INFORMACION_PERMISOS = {
  ADMINISTRAR: 'Administrar_Informacion_Contratos',
};

export const CONTRATACIONES_CONTACTOS_CONTRATOS = {
  ALTA: 'Crear_Contactos_Contratos',
  BAJA: 'Eliminar_Contactos_Contratos',
  MODIFICACION: 'Editar_Contactos_Contratos',
};

export const CONTRATACIONES_CONTABLES_PERMISOS = {
  ADMINISTRAR: 'Administrar_Contables_Contratos',
};

export const CONTRATACIONES_DOCUMENTACION_PERMISOS = {
  ADMINISTRAR: 'Administrar_Documentacion_Contratos',
  ALTA: 'Crear_Documentacion_Contratos',
  BAJA: 'Eliminar_Documentacion_Contratos',
};

export const CONTRATACIONES_CARTILLA_PERMISOS = {
  ADMINISTRAR: 'Administrar_Cartilla_Contratos',
};

export const CONTRATACIONES_CONVENIOS_PERMISOS = {
  ADMINISTRAR: 'Administrar_Convenios_Contratos',
};

export const CONTRATACIONES_MODULOS_PERMISOS = {
  ADMINISTRAR: 'Administrar_Modulos_Contratos',
};

export const CONTRATACIONES_INCLU_EXCLU_PERMISOS = {
  ADMINISTRAR: 'Administrar_Inclusiones_Exclusiones_Contratos',
};

export const CONTRATACIONES_LEGALES_PERMISOS = {
  ADMINISTRAR: 'Administrar_Legales_Contratos',
  ADMINISTRAR_DOCUMENTACION_LEGAL: 'Administrar_Documentacion_Legal_Contratos',
};

export const CONFIGURACION_CONTRATOS = {
  CONSULTA: 'Ver_Configuracion_Contratos',
  ALTA: 'Crear_Configuracion_Contratos',
  BAJA: 'Eliminar_Configuracion_Contratos',
  MODIFICACION: 'Editar_Configuracion_Contratos',
  ADMINISTRAR: 'Administrar_Configuracion_Contratos',
};

export const ARCHIVOS_CONTRATACIONES = {
  ADMINISTRAR: 'Administrar_Archivos_Contrataciones',
};

export const MEDICOS_PERMISOS = {
  ALTA: 'Alta_Medicos',
  CONSULTA: 'Ver_Medicos',
  MODIFICACION: 'Modificar_Medicos',
};

export const ESPECIALIDADES_PERMISOS = {
  ALTA: 'Especialidades_Alta',
  BAJA: 'Especialidades_Baja',
  MODIFICACION: 'Especialidades_Modificacion',
};

export const TOPES_MINIMOS_PERMISOS = {
  ALTA: 'TopesMinimos_Alta',
  BAJA: 'TopesMinimos_Baja',
  MODIFICACION: 'TopesMinimos_Modificacion',
};

export const MODIFICACION_PERMISOS_REPORTES = {
  MODIFICACION: 'PermisosReportes_Modificar',
};

export const ESTADISTICAS_MI_OSPEDYC = {
  GENERAL: 'Estadisticas_Mi_Ospedyc',
};

export const AUTORIZACIONES_MENU_PERMISOS = {
  INGRESO_AUTORIZACION: 'Ingreso_Autorizacion',
  GESTION_AUDITORIA: 'Gestion_Auditoria',
  GESTION_PRESUPUESTOS: 'Gestion_Presupuestos',
  SOLICITUDES_VIA_APP: 'Solicitudes_Via_App',
  SEGUIMIENTO_SOLICITUDES: 'Seguimiento_Solicitudes'
};

export const AUTORIZACIONES_PRACTICAS_AGRUPADAS = {
  ALTA: 'PracticasAgrupadas_Alta',
  BAJA: 'PracticasAgrupadas_Baja',
  CONSULTA: 'PracticasAgrupadas_Consulta',
  MODIFICACION: 'PracticasAgrupadas_Modificacion',
};

export const TURNOS_LABORATORIO = {
  AGREGAR: 'Laboratorio_AgregarPractica',
  AGREGAR_DEFAULT: 'LaboratorioDefault_AgregarPractica',
  ELIMINAR_DEFAULT: 'LaboratorioDefault_EliminarPractica',
};

export const AUTORIZACIONES_PERMISOS = {
  CANCELAR_SOLICITUD_AUTORIZADA: 'Cancelar_Solicitudes_Autorizadas',
  INGRESO_INTERNACION_DOMICILIARIA: 'Ingreso_Internacion_Domiciliaria',
  AUDITAR_SOLICITUDES: 'Auditar_Solicitudes',
  INGRESO_OXIGENO: 'Ingreso_Oxigeno',
  AUTORIZAR_AFILIADOS_BAJA: 'Autorizar_Afiliados_de_Baja',
  DELETE_SOLICITUDES_SEGUIMIENTO: 'Delete_Solicitudes_Seguimiento',
};

export const EFECTORES_AUDITORIA_TERRENO_PERMISOS = {
  EFECTORES_AUDITORIA_TERRENO: 'EFECTORES_AUDITORIA_TERRENO',
};

export const RELACION_PRACTICA_BANDEJA = {
  RELACION_PRACTICA_BANDEJA: 'RELACION_PRACTICA_BANDEJA',
};

export const ADMINISTRAR_AUTORIZACIONES_PERMISOS = {
  LIBERAR: 'AdministrarAutorizaciones_Liberar',
  CONSULTA: 'AdministrarAutorizaciones_Consulta',
};

export const ADMINISTRAR_PRESUPUESTOS_PERMISOS = {
  LIBERAR: 'AdministrarPresupuestos_Liberar',
  CONSULTA: 'AdministrarPresupuestos_Consulta',
};

export const LIQUIDACIONES_MENU_PERMISOS = {
  GESTION_FACTURAS: 'Gestion_Facturas',
};

export const ADMINISTRAR_LIQUIDACIONES_PERMISOS = {
  LIBERAR: 'AdministrarLiquidaciones_Liberar',
  CONSULTA: 'AdministrarLiquidaciones_Consulta',
};

export const LIQUIDACIONES_GESTION_PERMISOS = {
  CARGAR_LINEA: 'Carga_Linea_Comprobante',
  AUDITORIA_COMPROBANTE: 'Auditoria_Comprobante',
  GENERACION_SOLICITUD_PAGO: 'Generacion_Solicitud_Pago',
  ENVIO_TESORERIA: 'Envio_Tesoreria',
  MODIFICAR_DEBITO: 'Modificar_Debito',
  COMPROBANTES_RETORNADOS: "Comprobantes_Retornados",
  ANULAR_SOLICITUD_PAGO: "anular_solicitud_pago"
};

export const ADMINISTRAR_DISCAPACIDAD_PERMISOS = {
  LIBERAR: 'DiscapacidadAdministrar_Liberar',
  CONSULTA: 'DiscapacidadAdministrar_Consulta',
};

export const DISCAPACIDAD_GESTION_PERMISOS = {
  EN_CARGA: 'DiscapacidadBandeja_EnCarga',
  PENDIENTE: 'DiscapacidadBandeja_Pendiente',
  PENDIENTE_AUTORIZACION: 'DiscapacidadBandeja_PendienteAutorizacion',
};

export const MATERIALES = {
  CONSULTA: 'Materiales_Consulta',
  ALTA: 'Materiales_Alta',
  BAJA: 'Materiales_Eliminar',
  MODIFICACION: 'Materiales_Modificar',
};

export const RECUPERO = {
  CONSULTA: "Recupero_Consulta",
  ALTA: "Recupero_Alta",
  BAJA: "Recupero_Eliminar",
  MODIFICACION: "Recupero_Modificar",
};


export const TIPOS_DOCUMENTACION_SOLICITUD = {
  CONSULTA: 'TiposDocumentacionSolicitud_Consulta',
  ALTA: 'TiposDocumentacionSolicitud_Alta',
  BAJA: 'TiposDocumentacionSolicitud_Eliminar',
  MODIFICACION: 'TiposDocumentacionSolicitud_Modificar',
};

export const TIPOS_DOCUMENTACION_PRACTICA_SOLICITUD = {
  CONSULTA: 'TiposDocumentacionPracticaSolicitud_Consulta',
  ALTA: 'TiposDocumentacionPracticaSolicitud_Alta',
  BAJA: 'TiposDocumentacionPracticaSolicitud_Eliminar',
  MODIFICACION: 'TiposDocumentacionPracticaSolicitud_Modificar',
};

export const TIPOS_DOCUMENTACION = {
  CONSULTA: 'TiposDocumentacion_Consulta',
  ALTA: 'TiposDocumentacion_Alta',
  BAJA: 'TiposDocumentacion_Eliminar',
  MODIFICACION: 'TiposDocumentacion_Modificar',
};

export const TIPOS_DOCUMENTACION_PRESUPUESTO = {
  CONSULTA: 'TiposDocumentacionPresupuesto_Consulta',
  ALTA: 'TiposDocumentacionPresupuesto_Alta',
  BAJA: 'TiposDocumentacionPresupuesto_Eliminar',
  MODIFICACION: 'TiposDocumentacionPresupuesto_Modificar',
};

export const MESA_ENTRADA_PERMISOS = {
  CONSULTA: 'MesaEntrada_Consulta',
  ALTA: 'MesaEntrada_Alta',
  BAJA: 'MesaEntrada_Eliminar',
  MODIFICACION: 'MesaEntrada_Modificar',
};

export const EFECTORES_LIQUIDADOR_PERMISOS = {
  ALTA: 'EfectorPorLiquidador_Alta',
  BAJA: 'EfectorPorLiquidador_Eliminar',
  MODIFICACION: 'EfectorPorLiquidador_Modificar',
};

export const RECETAS_MENU_PERMISOS = {
  INGRESO_RECETAS: 'IngresarRecetas',
  HISTORIAL_RECETAS: 'HistorialRecetas',
  MEDICAMENTOS_RECETAS: 'Medicamentos',
};

export const EMPADRONAMIENTO_MENU_PERMISOS = {
  INGRESO_SOLICITUD: 'IngresarSolicitudEmpadronamiento',
  BANDEJA_SOLICITUD: 'BandejaSolicitudEmpadronamiento',
  INGRESO_SOLICITUD_AUDITORIA: 'IngresoSolicitudEmpadronamientoAudit',
  BANDEJA_SOLICITUD_AUDITORIA: 'BandejaSolicitudEmpadronamientoAudit',
  INGRESO_SOLICITUD_AUDITORIA_EXT: 'IngresoSolicitudEmpadronamientoAuditEsp',
  BANDEJA_SOLICITUD_AUDITORIA_EXT: 'BandejaSolicitudEmpadronamientoAuditEsp',
  BANDEJA_SOLICITUD_AUDITORIA_DISCA: 'BandejaSolicitudEmpadronamientoAuditDisca',
  INGRESO_SOLICITUD_AUDITORIA_DISCA: 'IngresoSolicitudEmpadronamientoAuditDisca'
};

export const MEDICACION_MENU_PERMISOS = {
  INGRESO_SOLICITUD: 'IngresarSolicitudMedicacion',
  BANDEJA_SOLICITUD: 'BandejaSolicitudMedicacion',
  INGRESO_SOLICITUD_AUDITORIA: 'IngresarSolicitudMedicacionAudit',
  BANDEJA_SOLICITUD_AUDITORIA: 'BandejaSolicitudMedicacionAudit',
  INGRESO_SOLICITUD_AUDITORIA_EXT: 'IngresarSolicitudMedicacionAuditEsp',
  BANDEJA_SOLICITUD_AUDITORIA_EXT: 'BandejaSolicitudMedicacionAuditEsp',
  BANDEJA_SOLICITUD_AUDITORIA_DISCA: 'BandejaSolicitudMedicacionAuditDisca',
  INGRESO_SOLICITUD_AUDITORIA_DISCA: 'IngresoSolicitudEmpadronamientoAuditDisca'
};

export const COMPRAS_MENU_PERMISOS = {
  COMPRAS_ACCESO: 'Compras_Acceso',
  COMPRAS_ACCESO_SOLICITUDES: 'ConsultarSolicitudes',
  COMPRAS_ACCESO_AUDITORIA_FACTURAS: 'ConsultarAuditoriaFacturas',
  COMPRAS_CARGAR_DOCUMENTACION_PARA_COTIZAR: 'Carga_Documentacion_Para_Cotizar',
  COMPRAS_ACCESO_PRESUPUESTOS: 'ComprasAccesoPresupuestos'
};
export const MENU_RECUPEROS = {
  CONSULTA_RECUPEROS: 'ConsultarRecuperos',
};
export const OFERENTES_PERMISOS = {
  OFERENTES_CONSULTA: 'ConsultarOferentes',
  OFERENTES_ALTA: 'AltaOferentes',
  OFERENTES_MODIFICAR: 'ModificarOferentes',
  OFERENTES_BAJA: 'EliminarOferentes',
};

export const REPORTES_CONTRATACIONES = {
  ADMINISTRAR: 'Administrar_Reportes_Contrataciones',
};
export const PATOLOGIAS_PERMISOS = {
  ALTA: 'Patologias_Alta',
  BAJA: 'Patologias_Baja',
  MODIFICACION: 'Patologias_Modificacion',
  CONSULTA: 'Patologias_Consulta',
};
export const DISCAPACIDAD_PERMISOS = {
  MENU: {
    CONSULTA: 'Discapacidad_Menu_Consulta',
    ALTA: 'Discapacidad_Menu_Alta',
    BAJA: 'Discapacidad_Menu_Eliminar',
    MODIFICACION: 'Discapacidad_Menu_Modificar',
  },
  CONFIGURACION: {
    CONSULTA: 'Discapacidad_Configuracion_Consulta',
    ALTA: 'Discapacidad_Configuracion_Alta',
    BAJA: 'Discapacidad_Configuracion_Eliminar',
    MODIFICACION: 'Discapacidad_Configuracion_Modificar',
  },
  ARCHIVOS: {
    CONSULTA: 'Discapacidad_Archivos_Consulta',
    ALTA: 'Discapacidad_Archivos_Alta',
    BAJA: 'Discapacidad_Archivos_Eliminar',
    MODIFICACION: 'Discapacidad_Archivos_Modificar',
  },
  CANCELAR_SOLICITUD_DISCAPACIDAD_AUTORIZADA: "CANCELAR_SOLICITUD_AUTORIZADA_DISCAPACIDAD",
};

export const RECLAMOS_PERMISOS = {
  ADMIN: 'Reclamos_Admin',
  INGRESO: "ReclamosIngreso",
  INGRESO_AFILIADO: "Ingreso_Reclamo_Afiliado",
  INGRESO_EFECTOR: "Ingreso_Reclamo_Efector",
  INGRESO_EXTERNOS: "Ingreso_Reclamo_Externos",
  BANDEJA_AFILIADO: "Bandeja_Reclamo_Afiliado",
  BANDEJA_EFECTOR: "Bandeja_Reclamo_Efector",
  BANDEJA_EXTERNAS: "Bandeja_Reclamo_Externos"
};

export const HCE_PERMISOS = {
  HCE: 'HCE_Ingreso',
  INFORMES: 'HCE_Informe',
  ENFERMERIA: 'HCE_InformeEnfermeria'
};

export const DISCAPACIDAD_NOMENCLADOR_PERMISOS = {
  CONSULTA: 'Discapacidad_Nomenclador_Consulta',
};

export const TOTEM_PERMISOS = {
  ADMINISTRAR: 'Administrar_Totem',
  ACCESO: 'Acceso_Totem',
  REPORTES: 'Reportes_Totem',
  RECEPCION: {
    RECEPCIONISTA: 'Recepcion_Totem',
  },
};

export const TOTEM_BASIC_PERMISOS = {
  ACCESO:  'Acceso_Totem_Basic',
  REPORTES: 'Reportes_Totem_Basic',
  ADMINISTRAR: {
    BOXES: 'Boxes_Totem_Basic',
    OPCIONES: 'Opciones_Totem_Basic',
    SUBOPCIONES: 'SubOpciones_Totem_Basic',
    OPCIONES_BOX: 'Opciones_Box_Totem_Basic',
    LIBERAR_BOXES: 'Liberar_Boxes_Totem_Basic',
  },
  RECEPCION: {
    SELECCION_BOX: 'Seleccion_Box_Totem_Basic',
    GESTION_SOLICITUDES: 'Gestion_Solicitudes_Totem_Basic',
  }
};

export const COMUNICACION_CON_EMPRESAS_PERMISOS = {
  CONSULTA: 'IngresarComunicacionEmpresas_Consulta',
};

export const TRASLADOS_PERMISOS = {
  GESTION_SOLICITUDES: {
    ADMINISTRACION: "GESTION_SOLICITUDES_TRASLADOS"
  },
  CONFIGURACION: {
    CONSULTA: "CONFIGURACION_CONSULTA_TRASLADOS",
    ALTA: "CONFIGURACION_ALTA_TRASLADOS",
    MODIFICAR: "CONFIGURACION_MODIFICAR_TRASLADOS",
    BAJA: "CONFIGURACION_BAJA_TRASLADOS",
  },
  AUDITORIA: {
    GESTION: "GESTION_AUDITORIA_TRASLADOS",
    ADMINISTRACION_GESTION: "GESTION_AUDITORIA_ADMINISTRACION_TRASLADOS",
    AUDITORIA_MEDICA: "GESTION_AUDITORIA_MEDICA"
  },
  INGRESO_SOLICITUDES: {
    ADMINISTRACION: "INGRESO_SOLICITUDES_TRASLADOS"
  }
}



export const ADMINISTRAR_ADICCIONES_PERMISOS = {
  LIBERAR: 'Adicciones_administrar_liberar',
  CONSULTA: 'Adicciones_administrar_consulta',
};

export const ADICCIONES_GESTION_PERMISOS = {
  EN_CARGA: 'Adicciones_bandeja_en_carga',
  PENDIENTE: 'Adicciones_bandeja_pendiente',
  PENDIENTE_AUTORIZACION: 'Adicciones_bandeja_pendiente_autorizacion',
};


export const ADICCIONES_PERMISOS = {
  MENU: {
    CONSULTA: 'Adicciones_menu_consulta',
    ALTA: 'Adicciones_menu_alta',
    BAJA: 'Adicciones_menu_eliminar',
    MODIFICACION: 'Adicciones_menu_modificar',
  },
  CONFIGURACION: {
    CONSULTA: 'Adicciones_configuracion_consulta',
    ALTA: 'Adicciones_configuracion_alta',
    BAJA: 'Adicciones_configuracion_eliminar',
    MODIFICACION: 'Adicciones_configuracion_modificar',
  },
  ARCHIVOS: {
    CONSULTA: 'Adicciones_archivos_consulta',
    ALTA: 'Adicciones_archivos_alta',
    BAJA: 'Adicciones_archivos_eliminar',
    MODIFICACION: 'Adicciones_archivos_modificar',
  },
  CANCELAR_SOLICITUD_ADICCIONES_AUTORIZADA: "Adicciones_cancelar_solicitud_autorizada",
};

export const ADICCIONES_NOMENCLADOR_PERMISOS = {
  CONSULTA: 'Adicciones_nomenclador_consulta',
};

export const TESORERIA_PERMISOS = {
  CONFIGURACION: {
    CONSULTA: 'consulta_us_ospedycdirecto',
  },
};

export const AUTORIZACIONES_AFILIADO_RECUPERO = {
  ALTA: 'Autorizaciones_Afiliado_Alta',
};